<template lang="pug">
.container
  .additional-info(v-if="medium.type.startsWith('PlayList')")
    .row
      .th {{$t('Playlist items:')}}
      .body {{ medium.PlayListItems.length }}
    .row(v-if="!medium.type.startsWith('PlayListExtended')")
      .th {{$t('Playlist duration:')}}
      .body {{ humanDuration(medium.playListDurationMs) }}
    .row(v-if="!medium.type.startsWith('PlayListExtended')")
      .th {{$t('Medium Created:')}}
      .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
  .additional-info(v-if="medium.type === 'Video'")
    .row
      .th {{$t('Video duration:')}}
      .body {{humanDuration(file.originalDurationMs)}}
    .row(v-if="file.convertedMetadata")
      .th {{$t('Framerate:')}}
      .body {{ Math.round(JSON.parse(file.convertedMetadata).r_frame_rate.split('/')[0] / JSON.parse(file.convertedMetadata).r_frame_rate.split('/')[1]) }} fps
    .row(v-if="file.convertedMetadata")
      .th  {{$t('Bitrate:')}}
      .body {{ Math.round(JSON.parse(file.convertedMetadata).bit_rate / 1000) }} kbps
    .row(v-if="file.convertedMetadata")
      .th {{$t('File size:')}}
      .body {{ humanFileSize(file.currentSize) }}
    .row(v-if="file.convertedMetadata")
      .th {{$t('Converted:')}}
      .body
        font-awesome-icon(:icon="file.currentsha256 !== file.originalsha256 ? 'check' : 'ban'")
    .row
      .th {{$t('Medium Created:')}}
      .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
    .row
      .th {{$t('File Created:')}}
      .body {{ $moment(file.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
  .additional-info(v-if="medium.type === 'Image'")
    .row
      .th {{$t('File size:')}}
      .body {{ humanFileSize(file.currentSize) }}
    .row
      .th {{$t('Mime type:')}}
      .body {{ file.originalMimeType }}
    .row
      .th {{$t('Medium Created:')}}
      .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
    .row
      .th {{$t('File Created:')}}
      .body {{ $moment(file.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
  .additional-info(v-if="medium.type === 'Audio'")
    .row
      .th
        el-button(@click="playMedium(medium)", size="mini", type="success")
          font-awesome-icon(icon="play")
      .th {{$t('Audio duration:')}}
      .body
        span {{humanDuration(file.originalDurationMs)}}
      .row
        .th {{$t('Medium Created:')}}
        .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
      .row
        .th {{$t('File Created:')}}
        .body {{ $moment(file.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
  .additional-info(v-if="medium.type === 'HTML5app' || medium.type.startsWith('PlayListExtended')")
    .row.checksum
      .th {{$t('Checksum:')}}
      .body(:title='file.currentsha256')
        .span.selectable {{ file.currentsha256 }}
        span ...
    .row.extension(v-if='extensionData')
      .th {{$t('Extension:')}}
      .body
        span {{ extensionData.name }} &nbsp;
        span v{{ extensionData.version }}
    .row
      .th {{$t('Medium Created:')}}
      .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
  .additional-info(v-if="medium.type === 'Custom'")
    .row.checksum
      .th {{$t('Checksum:')}}
      .body(:title='file.currentsha256')
        .span.selectable {{ file.currentsha256 }}
        span ...
    .row
      .th {{$t('Mime type:')}}
      .body
        span {{ file.originalMimeType }}
    .row
      .th {{$t('File size:')}}
      .body
        span {{ humanFileSize(file.originalSize) }}
    .row
      .th {{$t('Medium Created:')}}
      .body {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'

export default {
  props: ['medium'],
  mixins: [textUtils],
  components: {
  },
  async created () {
    if (this.medium.type === 'HTML5app' || this.medium.type.startsWith('PlayListExtended')) {
      this.extensionData = (await Vue.axios.get(`extension/${this.file.Extension}`)).data
    }
  },
  watch: {
    medium: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: [],
      extensionData: undefined
    }
  },
  methods: {
  },
  computed: {
    file () {
      return this.$store.state.File.file_list.find(f => f.id === this.medium.File)
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.additional-info {
  padding-left: 50px;
  border: 0px solid red;
  // height: 200px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  justify-content: center;
  .row {
    // width: 100%;
    // margin-left: 50%;
    font-size: $--font-size-base;
    line-height: 24px;
    display: flex;
    .th {
      width: 100px;
      color: $--color-text-secondary;
    }
    &.checksum {
      .body {
        .span {
          max-width: 200px;
          overflow: hidden;
          float: left;
          border: 0px solid green;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumBasicInfo.vue